<template>
  <ElDialog
    :title="$t('AGENTS.ADD_AGENT_TITLE')"
    :visible="value"
    width="20%"
    @close="closeAndReset"
  >
    <p v-if="$t('AGENTS.ADD_AGENT_DESC')">
      {{ $t('AGENTS.ADD_AGENT_DESC') }}
    </p>

    <ElForm
      ref="newAgent"
      :model="newAgent"
      :rules="rules"
      @submit.native.prevent="addAgent"
    >
      <ElFormItem :label="$t('AGENTS.AGENT_TITLE')" prop="title">
        <ElInput
          v-model="newAgent.title"
          type="text"
          name="title"
          required
          :disabled="isProcessing"
        />
      </ElFormItem>
      <ElFormItem :label="$t('EMAIL')" prop="email">
        <ElInput
          v-model="newAgent.email"
          type="email"
          name="email"
          dir="ltr"
          class="text-latin"
          required
          :disabled="isProcessing"
        />
      </ElFormItem>

      <ErrorsList v-if="newAgentFormErrors" :errors="newAgentFormErrors" />

      <!-- dirty hack until ElementUI ends up with a solution -->
      <input v-show="false" type="submit" />
    </ElForm>

    <div slot="footer" class="dialog-footer">
      <ElButton
        type="primary"
        :loading="isProcessing"
        @click.native.prevent="addAgent"
      >
        {{ $t('AGENTS.ADD_AGENT_BTN') }}
      </ElButton>
      <ElButton type="text" :plain="true" @click.native.prevent="closeAndReset">
        {{ $t('CANCEL') }}
      </ElButton>
    </div>
  </ElDialog>
</template>

<script>
import { Agents } from '@/api/api';
import modal from '@/mixins/modal';
import form from '@/mixins/form';

import ErrorsList from '@@/common/ErrorsList';

export default {
  name: 'AddAgent',

  components: {
    ErrorsList,
  },

  mixins: [modal, form],

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      newAgent: {
        email: '',
        title: '',
      },
      isProcessing: false,
      newAgentFormErrors: null,
    };
  },

  computed: {
    rules() {
      /* eslint-disable no-param-reassign */
      return ['title', 'email'].reduce(
        (acc, field) => ({
          [field]: {
            required: true,
            message: this.$t('VALIDATION_REQUIRED_ERR'),
            trigger: 'blur',
          },
          ...acc,
        }),
        {},
      );
    },
  },

  created() {
    // initialize an empty agent object
    this.resetNewAgentModel();
  },

  methods: {
    emptyNewAgent() {
      return {
        title: '',
        email: '',
      };
    },

    resetNewAgentModel() {
      this.newAgent = this.emptyNewAgent();
    },

    setLoading(status = false) {
      this.isProcessing = status;
    },

    addAgent() {
      if (!this.isValid('newAgent')) {
        return false;
      }

      this.setLoading(true);

      return Agents.invite(
        {},
        {
          title: this.newAgent.title,
          email: this.newAgent.email,
        },
      )
        .then(({ body: { message = '', agent_invitation: agent } }) => {
          this.$emit('add', agent);

          this.resetNewAgentModel();
          if (message) {
            this.$message.success(message);
          }

          this.newAgentFormErrors = null;

          this.closeAndReset();
        })
        .catch(({ body: { message, errors } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
          if (errors) {
            this.newAgentFormErrors = errors;
          }
        })
        .then(() => {
          this.setLoading(false);
        });
    },

    closeAndReset() {
      this.$emit('input', false);
      // reset form is proxied through the 'form' mixin
      this.resetForm('newAgent');
    },
  },
};
</script>
